import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import {
    UsersIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    CurrencyRupeeIcon,
    ChartBarIcon,
    TrophyIcon,
    GlobeAltIcon,
    BanknotesIcon
} from '@heroicons/react/24/outline';

// Icon mapping for stats
const iconMap = {
    UsersIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    CurrencyRupeeIcon,
    ChartBarIcon,
    TrophyIcon,
    GlobeAltIcon,
    BanknotesIcon
};

const StatCard = ({ stat, onEdit, onDelete }) => {
    const IconComponent = iconMap[stat.icon_name] || UsersIcon;

    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-slate-100">
            {/* Stat Preview */}
            <div className="p-6 bg-gradient-to-br from-slate-50 to-slate-100">
                <div className="flex items-center justify-between">
                    <div className={`w-16 h-16 rounded-2xl flex items-center justify-center bg-white shadow-sm`}>
                        <IconComponent className={`h-8 w-8 ${stat.color_class || 'text-primary-600'}`} />
                    </div>

                    {/* Display Order Badge */}
                    <div className="bg-white rounded-lg px-3 py-1.5 shadow-lg">
                        <span className="text-sm font-bold text-primary-600">
                            #{stat.display_order || 0}
                        </span>
                    </div>
                </div>

                {/* Value Display */}
                <div className="mt-4 text-center">
                    <span className="text-3xl font-bold text-slate-800">
                        {stat.value?.toLocaleString()}
                    </span>
                    <span className={`text-2xl font-bold ${stat.color_class || 'text-primary-600'}`}>
                        {stat.suffix}
                    </span>
                </div>
            </div>

            {/* Content */}
            <div className="p-5">
                {/* Active Badge */}
                <div className="mb-3">
                    <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${stat.is_active
                            ? 'bg-green-100 text-green-600'
                            : 'bg-slate-100 text-slate-500'
                        }`}>
                        {stat.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>

                {/* Label */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 line-clamp-1">
                    {stat.label}
                </h3>

                {/* Icon Name Tag */}
                <div className="mb-4">
                    <span className="px-2 py-1 bg-purple-50 text-purple-600 text-xs font-medium rounded-md">
                        {stat.icon_name}
                    </span>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2 pt-4 border-t border-slate-100">
                    <button
                        onClick={() => onEdit(stat)}
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                    </button>
                    <button
                        onClick={() => onDelete(stat.id)}
                        className="flex-1 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <TrashIcon className="h-4 w-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StatCard;
